"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dom = _interopRequireDefault(require("./dom"));

var _categoryRenderer = _interopRequireDefault(require("./category-renderer"));

var _util = _interopRequireDefault(require("./util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license
 * Copyright 2018 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* globals self, Util, CategoryRenderer */

/** @typedef {import('./dom.js')} DOM */
var PerformanceCategoryRenderer =
/*#__PURE__*/
function (_CategoryRenderer) {
  _inherits(PerformanceCategoryRenderer, _CategoryRenderer);

  function PerformanceCategoryRenderer() {
    _classCallCheck(this, PerformanceCategoryRenderer);

    return _possibleConstructorReturn(this, _getPrototypeOf(PerformanceCategoryRenderer).apply(this, arguments));
  }

  _createClass(PerformanceCategoryRenderer, [{
    key: "_renderMetric",

    /**
     * @param {LH.ReportResult.AuditRef} audit
     * @return {Element}
     */
    value: function _renderMetric(audit) {
      var tmpl = this.dom.cloneTemplate('#tmpl-lh-metric', this.templateContext);
      var element = this.dom.find('.lh-metric', tmpl);
      element.id = audit.result.id;

      var rating = _util["default"].calculateRating(audit.result.score, audit.result.scoreDisplayMode);

      element.classList.add("lh-metric--".concat(rating));
      var titleEl = this.dom.find('.lh-metric__title', tmpl);
      titleEl.textContent = audit.result.title;
      var valueEl = this.dom.find('.lh-metric__value', tmpl);
      valueEl.textContent = audit.result.displayValue || '';
      var descriptionEl = this.dom.find('.lh-metric__description', tmpl);
      descriptionEl.appendChild(this.dom.convertMarkdownLinkSnippets(audit.result.description));

      if (audit.result.scoreDisplayMode === 'error') {
        descriptionEl.textContent = '';
        valueEl.textContent = 'Error!';
        var tooltip = this.dom.createChildOf(descriptionEl, 'span');
        tooltip.textContent = audit.result.errorMessage || 'Report error: no metric information';
      }

      return element;
    }
    /**
     * @param {LH.ReportResult.AuditRef} audit
     * @param {number} scale
     * @return {Element}
     */

  }, {
    key: "_renderOpportunity",
    value: function _renderOpportunity(audit, scale) {
      var oppTmpl = this.dom.cloneTemplate('#tmpl-lh-opportunity', this.templateContext);
      var element = this.populateAuditValues(audit, oppTmpl);
      element.id = audit.result.id;

      if (!audit.result.details || audit.result.scoreDisplayMode === 'error') {
        return element;
      }

      var details = audit.result.details;

      if (details.type !== 'opportunity') {
        return element;
      } // Overwrite the displayValue with opportunity's wastedMs


      var displayEl = this.dom.find('.lh-audit__display-text', element);
      var sparklineWidthPct = "".concat(details.overallSavingsMs / scale * 100, "%");
      this.dom.find('.lh-sparkline__bar', element).style.width = sparklineWidthPct;
      displayEl.textContent = _util["default"].formatSeconds(details.overallSavingsMs, 0.01); // Set [title] tooltips

      if (audit.result.displayValue) {
        var displayValue = audit.result.displayValue;
        this.dom.find('.lh-load-opportunity__sparkline', element).title = displayValue;
        displayEl.title = displayValue;
      }

      return element;
    }
    /**
     * Get an audit's wastedMs to sort the opportunity by, and scale the sparkline width
     * Opportunities with an error won't have a details object, so MIN_VALUE is returned to keep any
     * erroring opportunities last in sort order.
     * @param {LH.ReportResult.AuditRef} audit
     * @return {number}
     */

  }, {
    key: "_getWastedMs",
    value: function _getWastedMs(audit) {
      if (audit.result.details && audit.result.details.type === 'opportunity') {
        var details = audit.result.details;

        if (typeof details.overallSavingsMs !== 'number') {
          throw new Error('non-opportunity details passed to _getWastedMs');
        }

        return details.overallSavingsMs;
      } else {
        return Number.MIN_VALUE;
      }
    }
    /**
     * @param {LH.ReportResult.Category} category
     * @param {Object<string, LH.Result.ReportGroup>} groups
     * @param {'PSI'=} environment 'PSI' and undefined are the only valid values
     * @return {Element}
     * @override
     */

  }, {
    key: "render",
    value: function render(category, groups, environment) {
      var _this = this;

      var element = this.dom.createElement('div', 'lh-category');

      if (environment === 'PSI') {
        var gaugeEl = this.dom.createElement('div', 'lh-score__gauge');
        gaugeEl.appendChild(this.renderScoreGauge(category, groups));
        element.appendChild(gaugeEl);
      } else {
        this.createPermalinkSpan(element, category.id);
        element.appendChild(this.renderCategoryHeader(category, groups));
      } // Metrics.


      var metricAuditsEl = this.renderAuditGroup(groups.metrics); // Metric descriptions toggle.

      var toggleTmpl = this.dom.cloneTemplate('#tmpl-lh-metrics-toggle', this.templateContext);
      var toggleEl = this.dom.find('.lh-metrics-toggle', toggleTmpl);
      metricAuditsEl.append.apply(metricAuditsEl, _toConsumableArray(toggleEl.childNodes));
      var metricAudits = category.auditRefs.filter(function (audit) {
        return audit.group === 'metrics';
      });
      var keyMetrics = metricAudits.filter(function (a) {
        return a.weight >= 3;
      });
      var otherMetrics = metricAudits.filter(function (a) {
        return a.weight < 3;
      });
      var metricsBoxesEl = this.dom.createChildOf(metricAuditsEl, 'div', 'lh-columns');
      var metricsColumn1El = this.dom.createChildOf(metricsBoxesEl, 'div', 'lh-column');
      var metricsColumn2El = this.dom.createChildOf(metricsBoxesEl, 'div', 'lh-column');
      keyMetrics.forEach(function (item) {
        metricsColumn1El.appendChild(_this._renderMetric(item));
      });
      otherMetrics.forEach(function (item) {
        metricsColumn2El.appendChild(_this._renderMetric(item));
      }); // 'Values are estimated and may vary' is used as the category description for PSI

      if (environment !== 'PSI') {
        var estValuesEl = this.dom.createChildOf(metricAuditsEl, 'div', 'lh-metrics__disclaimer');
        var disclaimerEl = this.dom.convertMarkdownLinkSnippets(_util["default"].UIStrings.varianceDisclaimer);
        estValuesEl.appendChild(disclaimerEl);
      }

      metricAuditsEl.classList.add('lh-audit-group--metrics');
      element.appendChild(metricAuditsEl); // Filmstrip

      var timelineEl = this.dom.createChildOf(element, 'div', 'lh-filmstrip-container');
      var thumbnailAudit = category.auditRefs.find(function (audit) {
        return audit.id === 'screenshot-thumbnails';
      });
      var thumbnailResult = thumbnailAudit && thumbnailAudit.result;

      if (thumbnailResult && thumbnailResult.details) {
        timelineEl.id = thumbnailResult.id;
        var filmstripEl = this.detailsRenderer.render(thumbnailResult.details);
        filmstripEl && timelineEl.appendChild(filmstripEl);
      } // Budgets


      var budgetAudit = category.auditRefs.find(function (audit) {
        return audit.id === 'performance-budget';
      });

      if (budgetAudit && budgetAudit.result.details) {
        var table = this.detailsRenderer.render(budgetAudit.result.details);

        if (table) {
          table.id = budgetAudit.id;
          table.classList.add('lh-audit');
          var budgetsGroupEl = this.renderAuditGroup(groups.budgets);
          budgetsGroupEl.appendChild(table);
          budgetsGroupEl.classList.add('lh-audit-group--budgets');
          element.appendChild(budgetsGroupEl);
        }
      } // Opportunities


      var opportunityAudits = category.auditRefs.filter(function (audit) {
        return audit.group === 'load-opportunities' && !_util["default"].showAsPassed(audit.result);
      }).sort(function (auditA, auditB) {
        return _this._getWastedMs(auditB) - _this._getWastedMs(auditA);
      });

      if (opportunityAudits.length) {
        // Scale the sparklines relative to savings, minimum 2s to not overstate small savings
        var minimumScale = 2000;
        var wastedMsValues = opportunityAudits.map(function (audit) {
          return _this._getWastedMs(audit);
        });
        var maxWaste = Math.max.apply(Math, _toConsumableArray(wastedMsValues));
        var scale = Math.max(Math.ceil(maxWaste / 1000) * 1000, minimumScale);
        var groupEl = this.renderAuditGroup(groups['load-opportunities']);
        var tmpl = this.dom.cloneTemplate('#tmpl-lh-opportunity-header', this.templateContext);
        this.dom.find('.lh-load-opportunity__col--one', tmpl).textContent = _util["default"].UIStrings.opportunityResourceColumnLabel;
        this.dom.find('.lh-load-opportunity__col--two', tmpl).textContent = _util["default"].UIStrings.opportunitySavingsColumnLabel;
        var headerEl = this.dom.find('.lh-load-opportunity__header', tmpl);
        groupEl.appendChild(headerEl);
        opportunityAudits.forEach(function (item) {
          return groupEl.appendChild(_this._renderOpportunity(item, scale));
        });
        groupEl.classList.add('lh-audit-group--load-opportunities');
        element.appendChild(groupEl);
      } // Diagnostics


      var diagnosticAudits = category.auditRefs.filter(function (audit) {
        return audit.group === 'diagnostics' && !_util["default"].showAsPassed(audit.result);
      }).sort(function (a, b) {
        var scoreA = a.result.scoreDisplayMode === 'informative' ? 100 : Number(a.result.score);
        var scoreB = b.result.scoreDisplayMode === 'informative' ? 100 : Number(b.result.score);
        return scoreA - scoreB;
      });

      if (diagnosticAudits.length) {
        var _groupEl = this.renderAuditGroup(groups['diagnostics']);

        diagnosticAudits.forEach(function (item) {
          return _groupEl.appendChild(_this.renderAudit(item));
        });

        _groupEl.classList.add('lh-audit-group--diagnostics');

        element.appendChild(_groupEl);
      } // Passed audits


      var passedAudits = category.auditRefs.filter(function (audit) {
        return (audit.group === 'load-opportunities' || audit.group === 'diagnostics') && _util["default"].showAsPassed(audit.result);
      });
      if (!passedAudits.length) return element;
      var clumpOpts = {
        auditRefs: passedAudits,
        groupDefinitions: groups
      };
      var passedElem = this.renderClump('passed', clumpOpts);
      element.appendChild(passedElem);
      return element;
    }
  }]);

  return PerformanceCategoryRenderer;
}(_categoryRenderer["default"]); // if (typeof module !== 'undefined' && module.exports) {
//   module.exports = PerformanceCategoryRenderer;
// } else {
//   self.PerformanceCategoryRenderer = PerformanceCategoryRenderer;
// }


var _default = PerformanceCategoryRenderer;
exports["default"] = _default;